import { Button, Dialog, IconButton } from "@mui/material"
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { FileUploader } from "react-drag-drop-files";
import React, { useEffect, useState } from "react";
import { useQueryClient, useMutation } from "@tanstack/react-query";
import { addCategory } from "../../apis/category";
import Spinner from '../../components/spinner';
import MuiAlert from '@mui/material/Alert';
import Slide from '@mui/material/Slide';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import { GrAdd } from "react-icons/gr";
import useCreate from "../../hooks/useCreate";
import Modal from '@mui/material/Modal';
import { toast } from "react-hot-toast";

const fileTypes = ["JPG", "PNG", "JPEG"];

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

function AddLens({ open, onClose }) {
  const queryClient = useQueryClient()
  const initialState = {
    name: "",
  }
  const [frameData, setFrameData] = useState(initialState)
  const [isError, setIsError] = useState(false)
  const [isSuccess, setIsSuccess] = useState(false)

  const handleInputData = (e) => {
    let value = e.target.value
    let data = {
      ...frameData,
      [e.target.name]: value,
    }
    setFrameData(data)
  }

  const handleCloseAndReset = () => {
    onClose()
    setIsSuccess(false)
    setIsError(false)
    setFrameData(initialState)
  }

  const handleBrandCreateSuccess = () => {
    handleCloseAndReset()
    toast.success("Lens Added Successfully",{
      position:"top-right",
      duration:3000
    })
  }

  const handleBrandCreateError = () => {

  }

  const { setDataToServer: setFrameDataToServer } = useCreate({
    refreshUrl: 'getLensList',
    url: 'createlens',
    onSuccess: handleBrandCreateSuccess,
    onError: handleBrandCreateError
  })

  const handleAddFrame = (e) => {
    e.preventDefault()
    setFrameDataToServer.mutate(frameData)
 
  }

  const closeErrorMessage = () => {
    setIsError(false)
  }

  useEffect(() => {
    isError && setTimeout(() => setIsError(false), [4000])
  }, [isError])

  return (
    <>
      <Modal open={open} onClose={onClose} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description" className="border-none outline-none">
        <div className='w-full absolute top-4 left-1/2 -translate-x-1/2 focus:outline-none'>
          <div className=' max-w-xl mx-auto bg-white'>
            <div className="head-modal">
              <div className='flex items-center space-x-4 px-6'>
                <div>
                  <IconButton onClick={onClose}>
                    <ArrowBackIcon />
                  </IconButton>
                </div>
                <h2 className='heading text-3xl'>Add Lens</h2>
              </div>
            </div>
            <div className="body-modal py-4 px-6 h-max">
              <form className='grid grid-cols-1 gap-4' onSubmit={handleAddFrame}>
                <div>
                  <label htmlFor="Lens Name" className='label'>Lens Name <small className="text-red-700">*</small></label>
                  <input required type="text" placeholder='Enter Lens' name='name' className='input' value={frameData.name} onChange={handleInputData} />
                </div>
                {isError && <Alert onClose={closeErrorMessage} className='mb-4' severity="error" sx={{ width: '100%' }}>{setFrameDataToServer?.error?.message}, Please try again later</Alert>}
                {isSuccess && <Alert onClose={closeErrorMessage} className='mb-4' severity="success" sx={{ width: '100%' }}>Category Added Succesfully</Alert>}
                <div className=' space-x-4 text-center pb-5'>
                  {setFrameDataToServer.isLoading ?
                    <Spinner /> :
                    <>
                      <Button type='submit' variant="contained">Save</Button>
                      <Button variant="outlined" onClick={handleCloseAndReset}>Close</Button>
                    </>}
                </div>
              </form>
            </div>
          </div>
        </div>
      </Modal>
    </>
  )
}

export default AddLens